import { Outlet } from 'react-router-dom';
import * as React from 'react';

function NoLayout() {
  return <React.Fragment>
    <Outlet />
  </React.Fragment>
}

export default NoLayout